import React, { useState } from 'react';
import { XIcon, BellIcon, PlusIcon, CheckIcon, CalendarIcon } from 'lucide-react';
interface ClientInfoOverlayProps {
  onClose: () => void;
}
export function ClientInfoOverlay({
  onClose
}: ClientInfoOverlayProps) {
  const [clientData, setClientData] = useState({
    name: 'Priya Shah',
    phone: '+91 98765 43210',
    label: 'active',
    weight: '65',
    height: '165',
    medications: 'None',
    allergies: 'Peanuts, Shellfish',
    notes: 'Prefers vegetarian options. Works late hours, needs flexible dinner timing.'
  });
  const [showSaved, setShowSaved] = useState(false);
  const [showAddReminder, setShowAddReminder] = useState(false);
  const handleSave = () => {
    setShowSaved(true);
    setTimeout(() => setShowSaved(false), 2000);
  };
  const reminders = [{
    id: '1',
    text: 'Follow-up on meal plan progress',
    date: 'Tomorrow, 10:00 AM'
  }, {
    id: '2',
    text: 'Send weekly grocery list',
    date: 'Friday, 9:00 AM'
  }];
  const timeline = [{
    id: '1',
    event: 'Plan started',
    date: '2 weeks ago'
  }, {
    id: '2',
    event: 'First check-in completed',
    date: '1 week ago'
  }, {
    id: '3',
    event: 'Meal plan adjusted',
    date: '3 days ago'
  }];
  return <div className="fixed inset-0 z-50 flex">
      <div className="flex-1 bg-black bg-opacity-50" onClick={onClose} />
      <div className="w-full max-w-md bg-white shadow-2xl overflow-y-auto animate-slide-in-right">
        <div className="sticky top-0 bg-white border-b border-gray-200 z-10 p-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-[#212121]">Client Info</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors">
            <XIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="p-4 space-y-6">
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 bg-[#5B8E87] bg-opacity-10 rounded-full flex items-center justify-center">
                <span className="text-[#5B8E87] font-semibold text-xl">PS</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg text-[#212121]">
                  {clientData.name}
                </h3>
                <p className="text-sm text-gray-600">{clientData.phone}</p>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-[#212121] mb-2">
                Status Label
              </label>
              <select value={clientData.label} onChange={e => setClientData({
              ...clientData,
              label: e.target.value
            })} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all">
                <option value="lead">Lead</option>
                <option value="active">Active Client</option>
                <option value="past">Inactive Client</option>
                <option value="followup">Follow-up Required</option>
              </select>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="font-semibold text-base text-[#212121] mb-4">
              Vitals
            </h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-[#212121] mb-2">
                  Weight (kg)
                </label>
                <input type="number" value={clientData.weight} onChange={e => setClientData({
                ...clientData,
                weight: e.target.value
              })} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
              </div>
              <div>
                <label className="block text-sm font-medium text-[#212121] mb-2">
                  Height (cm)
                </label>
                <input type="number" value={clientData.height} onChange={e => setClientData({
                ...clientData,
                height: e.target.value
              })} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-all transition-all" />
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-[#212121] mb-2">
                Medications
              </label>
              <input type="text" value={clientData.medications} onChange={e => setClientData({
              ...clientData,
              medications: e.target.value
            })} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-[#212121] mb-2">
                Allergies
              </label>
              <input type="text" value={clientData.allergies} onChange={e => setClientData({
              ...clientData,
              allergies: e.target.value
            })} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="font-semibold text-base text-[#212121] mb-4">
              Notes
            </h3>
            <textarea value={clientData.notes} onChange={e => setClientData({
            ...clientData,
            notes: e.target.value
          })} rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all resize-none" />
            <button onClick={handleSave} className="w-full mt-3 bg-[#5B8E87] text-white font-semibold py-3 rounded-xl hover:bg-[#4F7A74] transition-colors flex items-center justify-center gap-2">
              {showSaved ? <>
                  <CheckIcon className="w-5 h-5" />
                  Saved
                </> : 'Save Notes'}
            </button>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-base text-[#212121]">
                Reminders
              </h3>
              <button onClick={() => setShowAddReminder(!showAddReminder)} className="text-[#5B8E87] font-medium text-sm flex items-center gap-1">
                <PlusIcon className="w-4 h-4" />
                Add
              </button>
            </div>
            {showAddReminder && <div className="mb-4 p-4 bg-gray-50 rounded-xl space-y-3">
                <input type="text" placeholder="Reminder message..." className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
                <div className="flex gap-2">
                  <input type="date" className="flex-1 px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
                  <input type="time" className="flex-1 px-4 py-3 rounded-xl border border-gray-300 focus:border-[#5B8E87] focus:ring-2 focus:ring-[#5B8E87] focus:ring-opacity-20 outline-none transition-all" />
                </div>
                <button className="w-full bg-[#5B8E87] text-white font-semibold py-3 rounded-xl hover:bg-[#4F7A74] transition-colors">
                  Save Reminder
                </button>
              </div>}
            <div className="space-y-3">
              {reminders.map(reminder => <div key={reminder.id} className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
                  <BellIcon className="w-5 h-5 text-gray-700 flex-shrink-0 mt-0.5" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-[#212121]">
                      {reminder.text}
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      {reminder.date}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
            <h3 className="font-semibold text-base text-[#212121] mb-4">
              Timeline
            </h3>
            <div className="space-y-4">
              {timeline.map((item, index) => <div key={item.id} className="flex gap-3">
                  <div className="flex flex-col items-center">
                    <div className="w-3 h-3 bg-[#5B8E87] rounded-full" />
                    {index < timeline.length - 1 && <div className="w-0.5 h-full bg-gray-200 mt-1" />}
                  </div>
                  <div className="flex-1 pb-4">
                    <p className="text-sm font-medium text-[#212121]">
                      {item.event}
                    </p>
                    <p className="text-xs text-gray-600 mt-1">{item.date}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}